export default "__VITE_ASSET__DbNTDcVg__"